import { Model } from '@zajno/common/models/Model';
import type { IValueModelReadonly } from '@zajno/common/models/types';
import { IEvent } from '@zajno/common/observing/event';

export type ILocation = { pathname: string };

export type LocationChangedData = { prev: ILocation, next: ILocation };

export interface INavigation {
    replace(route: string): void;
    push(route: string): void;
    goBack(): void;

    readonly onPathChanged: IEvent<LocationChangedData>;
}

const _navigation = new Model<INavigation>();
export const Navigation: IValueModelReadonly<INavigation> = _navigation;

export function setNavigationInstance(i: INavigation) {
    if (!i) {
        throw new Error('invalid operation');
    }

    _navigation.setValue(i);
    return () => {
        // TODO cleanup correctly
        _navigation.reset();
    };
}
